import { BaseResponse } from 'common/types/api'
import api from 'core/api'
import { IotDeviceApi } from 'modules/iot/api/types'

export const getOldestIotDeviceByPond = (farmId: string, pondId: string) =>
  api.get<BaseResponse<IotDeviceApi>>(
    `/farms/${farmId}/ponds/${pondId}/iot-devices/oldest`,
    { params: { deviceType: 'WATER_QUALITY_SENSOR' } }
  )
